import React from "react";
import Translator from "Languages/Utility/Translator";
import { convertToEnglishNumber } from "./convertToEnglishNumber";
import { read } from "./LocalStorage";

// rules = {
//   number : true,
//   decimal : true,
//   minus : true,
//   price : true,
// }

function CheckTableValidation(value, rules) {
  value = convertToEnglishNumber(value.toString().replaceAll(",", ""));
  const precision = read("precision");
  let validation = { valid: true, message: "" };
  const decimalPlaces = 4;

  //! ------------------------------------------------- [number]
  if (rules.number) {
    const enValue = +convertToEnglishNumber(value);
    const _test = /^\d+$/.test(enValue);
    if (!_test && !rules.decimal) {
      validation.valid = false;
      validation.message = <Translator id="typeNumberError" noSpan />;
    }
    //! ------------------------------------------------- [decimal]
    if (rules.decimal) {
      const regex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlaces}})?$`);
      const _test = regex.test(enValue);
      if (!_test) {
        validation.valid = false;
        validation.message = <Translator id="invalidDecimalFormat" noSpan />;
      }
    }
    //! ------------------------------------------------- [minus]
    if (rules.minus) {
      const regex = new RegExp(`^-?\\d+(\\.\\d{1,${decimalPlaces}})?$`);
      const _test = regex.test(enValue);
      if (!_test) {
        validation.valid = false;
        validation.message = <Translator id="typeNumberError" noSpan />;
      }
    }
  }

  //! ------------------------------------------------- [price]
  if (rules.price) {
    const enValue = +convertToEnglishNumber(value);
    if (isNaN(enValue)) {
      validation.valid = false;
      validation.message = <Translator id="typeNumberError" noSpan />;
    } else {
      if (precision === 0) {
        const _test = /^\d+$/.test(enValue);
        if (!_test) {
          validation.valid = false;
          validation.message = <Translator id="typeNumberError" noSpan />;
        }
      } else {
        const regex = new RegExp(`^\\d+(\\.\\d{1,${precision}})?$`);
        const _test = regex.test(enValue);
        if (!_test) {
          validation.valid = false;
          validation.message = (
            <Translator id="minimum_decimal_WID" S1={precision} noSpan />
          );
        }
      }
    }
  }

  if (validation.valid) return true;
  else
    return {
      valid: false,
      message: validation.message,
    };
}

export default CheckTableValidation;
